<div class="position">
  <div id="barra-brasil" style="background: #7f7f7f; height: 42px; padding: 0 0 0 10px; display: block;"></div>
</div>
